import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Organization, OrganizationClient, UserClient, UserProfile, UserRoleTypes } from "src/app/web-api-client";
import { UserEditComponent } from "../user-edit/user-edit.component";
import { ConfirmModalComponent } from "../../../modals/confirm-modal/confirm-modal.component";
import { SuccessModalComponent } from "../../../modals/success-modal/success-modal.component";
import { UnSuccessModalComponent } from "../../../modals/failed-modal/failed-modal.component";
import { OrgEditComponent } from "./org-edit/org-edit.component";
import { OrgCreationComponent } from "./org-creation/org-creation.component";
import { OrganizationalTypes } from "../../../enums/organizational-types.enum";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class OrganizationComponent implements OnInit {

  public isLoaded: boolean = false;
  public OrganizationTypes: OrganizationalTypes;
  selectedOrganization: Organization;
  public orgs: Organization[];

  // Assuming you already have a property for all the organizations
  public searchQuery: string = '';
  public filteredOrgs: Organization[] = [];




  constructor(private readonly changeDetectionRef:ChangeDetectorRef, private readonly modalService: NgbModal,public orgClient:OrganizationClient){

  }

  ngOnInit(): void {

    this.loadData();

  }


  private loadData() {
    this.orgClient.getList().subscribe((orgs: Organization[]) => {
      this.isLoaded = false;
      this.orgs = orgs;
      this.filteredOrgs = orgs;
            this.isLoaded = true;
            this.changeDetectionRef.detectChanges();
        });
  }


  public filterOrgs() {
    if (this.searchQuery) {
      this.filteredOrgs = this.orgs.filter(org =>
        org.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        org.description.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        this.getOrgText(org.organizationalType).toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        this.getEnablePayment(org).toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredOrgs = this.orgs;
    }
  }


 public onSelected(organization:Organization){
   if (this.isSelected(organization)){
    this.selectedOrganization = null;
  }
  else{

     this.selectedOrganization = organization;
  }
 }

 public isSelected(organization:Organization):boolean{
   return this.selectedOrganization == organization;
 }

  public getOrgText(orgType: number):String {
    return OrganizationalTypes[orgType].toString();
  }


  public getEnablePayment(org: Organization) {
    return org.includePaymentProcess ? 'Да' : 'Не';
  }

  public getEnableVIK(org: Organization) {
    return org.enableVikModule ? 'Да' : 'Не';
  }

  public getEnableService(org: Organization) {
    return org.enableServiceProvider ? 'Да' : 'Не';
  }


public onCreation():void{

  let modalRef = this.modalService.open(OrgCreationComponent, { size: 'xl', centered: true, backdrop: 'static' });
  modalRef.componentInstance.organizations = this.orgs;

  modalRef.componentInstance.onClose.subscribe(r => {
    this.loadData();
  })
}


public onDelete(): void {

    let modalRef = this.modalService.open(ConfirmModalComponent);

    modalRef.componentInstance.onClose.subscribe(result => {
      if (result === true) {

        this.orgClient.remove(this.selectedOrganization.id).subscribe(r => {
          this.modalService.open(SuccessModalComponent);
        })
      }
      else {
        this.modalService.open(UnSuccessModalComponent);
      }
    });


  }

  public onEdit(): void {

    let modalRef = this.modalService.open(OrgEditComponent, { size: 'xl', centered: true, backdrop: 'static' });
    modalRef.componentInstance.editOrg = this.selectedOrganization;
    modalRef.componentInstance.organizations = this.orgs;
    modalRef.componentInstance.onClose.subscribe(r => {
      this.loadData();
    })
    }

}
